export enum CELL_RENDERER {
  input_number = 'input-number',
  checkbox = 'checkbox',
  entity_link_renderer = 'entityLinkRenderer',
  float_input_renderer = 'floatInputRenderer',
  select_renderer = 'selectRenderer',
  empty_renderer = 'emptyRenderer',
  date_renderer = 'dateRenderer',
  utc_date_renderer = 'utcDateRenderer',
  icon_renderer = 'iconRenderer',
  icon_button_renderer = 'iconButtonRenderer',
  common_actions_renderer = 'commonActionsRenderer',
  order_actions_renderer = 'orderActionsRenderer',
  link_renderer = 'linkRenderer',
  bell_renderer = 'bellRenderer',
  tag_renderer = 'tagRenderer',
  price_input_renderer = 'priceInputRenderer',
  ag_group_cell_renderer = 'agGroupCellRenderer',
  transfer_actions_renderer = 'transferActionsRenderer',
  transfer_group_actions_renderer = 'transferGroupActionsRenderer',
  transfer_group_template_actions_renderer = 'transferGroupTemplateActionsRenderer',
  stand_worksheet_actions_renderer = 'standWorksheetActionsRenderer',
  site_inventory_count_actions_renderer = 'siteInventoryCountActionsRenderer',
  integer_renderer = 'integerRenderer',
  buffered_reference_renderer = 'bufferedReferenceRenderer',
  specific_data_renderer = 'specificDataRenderer',
  incomplete_transfer_actions_renderer = 'incompleteTransferActionsRenderer',
  custom_text_renderer = 'customTextRenderer',
  icons_renderer = 'iconsRenderer',
  custom_select_renderer = 'customSelectRenderer',
  count_renderer = 'countRenderer',
  hinted_text_renderer = 'hintedTextRenderer',
  modal_link_render = 'modalLinkRender',
  filtered_order_actions_render = 'filteredOrderActionsRender',
  filtered_transfer_actions_render = 'filteredTransferActionsRender',
  transfer_request_actions_render = 'transferRequestActionsRender',
  prepared_string_renderer = 'preparedStringRenderer',
  array_string_renderer = 'arrayStringRenderer',
  switch_radio_renderer = 'switchRadioRenderer',
}
